import React from 'react';

const AboutSection = () => {
    const dataSources = [
        {
            name: "U.S. Census Bureau",
            description: "Population, demographics, housing, income, education, commute data (13 metrics)",
            website: "https://www.census.gov",
            api: "https://api.census.gov/data",
            updateFrequency: "Annual (ACS 5-year estimates)",
            status: "✅ Active",
            metrics: ["Population", "Median Household Income", "Median Family Income", "Poverty Rate", "Bachelor's Degree %", 
                     "Median Home Value", "Median Rent", "Uninsured Rate", "Population Density", "Homeownership Rate", 
                     "Median Age", "Average Commute Time", "Education Attainment"]
        },
        {
            name: "Centers for Disease Control (CDC)",
            description: "Life expectancy, infant mortality rates (2 metrics)",
            website: "https://www.cdc.gov",
            api: "https://data.cdc.gov",
            updateFrequency: "Annual",
            status: "✅ Active",
            metrics: ["Life Expectancy", "Infant Mortality Rate"]
        },
        {
            name: "Bureau of Labor Statistics",
            description: "State unemployment rates (1 metric)",
            website: "https://www.bls.gov",
            api: "https://api.bls.gov",
            updateFrequency: "Monthly",
            status: "✅ Active",
            metrics: ["Unemployment Rate"]
        },
        {
            name: "Bureau of Economic Analysis",
            description: "GDP per capita by state (1 metric)",
            website: "https://www.bea.gov",
            api: "https://apps.bea.gov/api",
            updateFrequency: "Annual",
            status: "✅ Active",
            metrics: ["GDP Per Capita"]
        },
        {
            name: "Tax Foundation",
            description: "State income and sales tax rates (2 metrics)",
            website: "https://taxfoundation.org",
            updateFrequency: "Annual",
            status: "✅ Active",
            metrics: ["State Income Tax Rate", "Sales Tax Rate"]
        },
        {
            name: "FBI Uniform Crime Reporting",
            description: "Violent and property crime statistics (2 metrics)",
            website: "https://ucr.fbi.gov",
            api: "https://crime-data-explorer.app.cloud.gov/api",
            updateFrequency: "Annual",
            status: "✅ Active",
            metrics: ["Violent Crime Rate", "Property Crime Rate"]
        },
        {
            name: "Environmental Protection Agency (EPA)",
            description: "Air quality index data (1 metric)",
            website: "https://www.epa.gov",
            api: "https://aqs.epa.gov/api",
            updateFrequency: "Annual",
            status: "✅ Active",
            metrics: ["Air Quality Index"]
        },
        {
            name: "Federal Communications Commission",
            description: "Broadband availability percentages (1 metric)",
            website: "https://www.fcc.gov",
            api: "https://opendata.fcc.gov",
            updateFrequency: "Annual",
            status: "✅ Active",
            metrics: ["Broadband Availability"]
        },
        {
            name: "Department of Labor",
            description: "State minimum wage standards (1 metric)",
            website: "https://www.dol.gov",
            updateFrequency: "As changes occur",
            status: "✅ Active",
            metrics: ["Minimum Wage"]
        },
        {
            name: "National Center for Education Statistics",
            description: "High school graduation rates (1 metric)",
            website: "https://nces.ed.gov",
            api: "https://data-nces.opendata.arcgis.com",
            updateFrequency: "Annual",
            status: "✅ Active",
            metrics: ["High School Graduation Rate"]
        },
        {
            name: "Ookla Speedtest",
            description: "Average internet speeds by state (1 metric)",
            website: "https://www.speedtest.net/global-index",
            updateFrequency: "Quarterly",
            status: "✅ Active",
            metrics: ["Internet Speed"]
        },
        {
            name: "Various Economic Sources",
            description: "Cost of living index compilation (1 metric)",
            website: "https://www.bea.gov",
            updateFrequency: "Annual",
            status: "✅ Active",
            metrics: ["Cost of Living Index"]
        },
        {
            name: "Official Government Records",
            description: "Complete tenure data for all 100 Senators, 50 Governors, 435 Representatives",
            website: "https://www.senate.gov",
            updateFrequency: "As changes occur",
            status: "✅ Active",
            metrics: ["Government Officials Data"]
        }
    ];

    return (
        <div style={{
            padding: '20px',
            backgroundColor: '#fff',
            borderRadius: '8px',
            margin: '20px 0',
            border: '2px solid #1E3A8A',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
            <h3 style={{ 
                color: '#1E3A8A', 
                borderBottom: '2px solid #DC143C',
                paddingBottom: '10px',
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
            }}>
                📊 About TheAmerica.App - Data Sources & Credits
            </h3>

            <div style={{
                marginBottom: '25px',
                padding: '15px',
                backgroundColor: '#F8FBFF',
                borderRadius: '6px',
                border: '1px solid #E0E0E0'
            }}>
                <h4 style={{
                    color: '#333',
                    marginBottom: '10px',
                    fontSize: '16px'
                }}>
                    Our Mission
                </h4>
                <p style={{
                    fontSize: '14px',
                    lineHeight: '1.6',
                    color: '#555'
                }}>
                    TheAmerica.App provides comprehensive, accurate, and up-to-date information about all 50 U.S. states 
                    by aggregating data from trusted sources including government agencies, non-profit research organizations, 
                    and industry-standard data providers, ensuring transparency and reliability.
                </p>
            </div>

            <div style={{
                marginBottom: '25px',
                padding: '15px',
                backgroundColor: '#E8F5E9',
                borderRadius: '6px',
                border: '1px solid #4CAF50'
            }}>
                <h4 style={{
                    color: '#333',
                    marginBottom: '10px',
                    fontSize: '16px'
                }}>
                    Platform Statistics
                </h4>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                    gap: '15px',
                    fontSize: '14px'
                }}>
                    <div>
                        <strong style={{ color: '#1E3A8A' }}>28</strong> Total Metrics
                    </div>
                    <div>
                        <strong style={{ color: '#1E3A8A' }}>50</strong> U.S. States
                    </div>
                    <div>
                        <strong style={{ color: '#1E3A8A' }}>1,400+</strong> Data Points
                    </div>
                    <div>
                        <strong style={{ color: '#1E3A8A' }}>13</strong> Data Sources
                    </div>
                    <div>
                        <strong style={{ color: '#1E3A8A' }}>585</strong> Government Officials
                    </div>
                    <div>
                        <strong style={{ color: '#1E3A8A' }}>100%</strong> Free & Open Source
                    </div>
                </div>
            </div>

            <div style={{
                marginBottom: '25px',
                padding: '15px',
                backgroundColor: '#F8FBFF',
                borderRadius: '6px',
                border: '1px solid #E0E0E0'
            }}>
                <h4 style={{
                    color: '#333',
                    marginBottom: '15px',
                    fontSize: '16px',
                    borderLeft: '4px solid #4CAF50',
                    paddingLeft: '10px'
                }}>
                    Data Sources & Credits
                </h4>
                
                <div style={{
                    display: 'grid',
                    gap: '12px'
                }}>
                    {dataSources.map((source, index) => (
                        <div key={index} style={{
                            padding: '12px',
                            backgroundColor: 'white',
                            borderRadius: '4px',
                            border: '1px solid #E0E0E0'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                marginBottom: '8px'
                            }}>
                                <a 
                                    href={source.website}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        fontSize: '15px',
                                        fontWeight: 'bold',
                                        color: '#1E3A8A',
                                        textDecoration: 'none'
                                    }}
                                    onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                    onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                                >
                                    {source.name} 🔗
                                </a>
                                <span style={{
                                    fontSize: '11px',
                                    color: '#666',
                                    backgroundColor: '#F0F0F0',
                                    padding: '2px 6px',
                                    borderRadius: '4px'
                                }}>
                                    {source.updateFrequency}
                                </span>
                            </div>
                            <div style={{
                                fontSize: '13px',
                                color: '#555',
                                marginBottom: '4px'
                            }}>
                                {source.description}
                            </div>
                            {source.api && (
                                <div style={{
                                    fontSize: '12px',
                                    color: '#888'
                                }}>
                                    API: <a 
                                        href={source.api}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            color: '#1E90FF',
                                            textDecoration: 'none'
                                        }}
                                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                                    >
                                        {source.api}
                                    </a>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            <div style={{
                marginTop: '25px',
                padding: '15px',
                backgroundColor: '#FFF9E6',
                borderRadius: '6px',
                border: '1px solid #FFD700'
            }}>
                <h4 style={{
                    color: '#333',
                    marginBottom: '10px',
                    fontSize: '16px'
                }}>
                    License & Attribution
                </h4>
                <p style={{
                    fontSize: '13px',
                    lineHeight: '1.6',
                    color: '#555',
                    marginBottom: '10px'
                }}>
                    TheAmerica.App is licensed under the <strong>GNU Affero General Public License v3.0 (AGPLv3)</strong>.
                </p>
                <p style={{
                    fontSize: '13px',
                    lineHeight: '1.6',
                    color: '#555'
                }}>
                    <strong>Developer:</strong> Joshua Walderbach (@8bits1beard)<br/>
                    <strong>Repository:</strong> <a 
                        href="https://github.com/8bits1beard-io/project-theamerica"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            color: '#1E90FF',
                            textDecoration: 'none'
                        }}
                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                    >
                        GitHub Repository
                    </a><br/>
                    <strong>Version:</strong> 0.0.6
                </p>
            </div>

            <div style={{
                marginTop: '20px',
                padding: '12px',
                backgroundColor: '#E8F4FD',
                borderRadius: '4px',
                border: '1px solid #B0D4F1',
                textAlign: 'center'
            }}>
                <p style={{
                    fontSize: '13px',
                    color: '#1E3A8A',
                    margin: 0
                }}>
                    Data is aggregated from official government sources, trusted non-profits, and industry-standard providers. 
                    While we strive for accuracy, please verify critical information with the original sources.
                </p>
            </div>
        </div>
    );
};

export default AboutSection;